// Row lookup and number formatting for /ielts/calculator.
//
// ⛔ No arithmetic here. The server computes every position of the fader under
// both schedules before the page is sent — 16 positions × 2 schedules — and
// this file picks a row out of what it sent. A second implementation of the
// engine in JavaScript would drift from the Ruby one, and the only way to catch
// that would be a fixture comparing the two, which is machinery this avoids.

/**
 * @param {Array<Object>} variants rows the server precomputed
 * @param {string} schedule "part-time" or "full-time"
 * @param {number} dailyHours the fader position
 * @returns {Object|undefined} the row, or undefined when the server sent none
 */
export function selectVariant (variants, schedule, dailyHours) {
  if (!Array.isArray(variants)) return undefined

  return variants.find(
    (variant) => variant.schedule === schedule && Number(variant.dailyHours) === Number(dailyHours)
  )
}

/**
 * One decimal place, with a trailing zero dropped: the board reads "6.5 小時"
 * and "3 小時", never "3.0 小時".
 *
 * ⛔ A value that is not a number comes back empty rather than as "NaN": a
 * missing figure must leave a blank, not a word the reader has to decode.
 */
export function formatNumber (value) {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return ''

  return String(Math.round(Number(value) * 10) / 10)
}
